import { sendRepeatOrder } from "@/models/socket/orders.model";
import { AppContext } from "@/services/AppContext/appContext";
import { Button } from "@/shadcn/components/ui/button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shadcn/components/ui/dialog";
import { genericFailureToast, genericSuccessToast } from "@/utils/utils.util";
import React, { useContext, useState } from "react";

type RepeatOrderProps = {
  orderID: string;
};

const RepeatOrder: React.FC<RepeatOrderProps> = ({ orderID }) => {
  const { userRole } = useContext(AppContext);
  const [submitting, setSubmitting] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  // Use dialog to confirm repeat action to prevent accidental repeats
  async function handleRepeatOrder() {
    setSubmitting(true);
    const response = await sendRepeatOrder(orderID);
    if (response.rStatus === "success") {
      genericSuccessToast("New quote created successfully");
    } else {
      genericFailureToast(
        response.rData || "Failed to repeat order. Please try again later."
      );
    }
    setSubmitting(false);
    setDialogOpen(false); // close dialog after action
  }

  return (
    userRole === "approved_user" && (
      <>
        <Button
          className="mb-4"
          onClick={() => setDialogOpen(true)}
          disabled={submitting}
        >
          Repeat Order
        </Button>
        <Dialog open={dialogOpen} onOpenChange={setDialogOpen}>
          <DialogContent className="sm:max-w-[425px]">
            <DialogHeader>
              <DialogTitle>Repeat Order</DialogTitle>
              <DialogDescription></DialogDescription>
            </DialogHeader>
            <div className="space-y-4">
              <p>Are you sure you want to repeat this order?</p>
            </div>
            <DialogFooter>
              <DialogClose asChild>
                <Button variant="outline">Cancel</Button>
              </DialogClose>
              <Button onClick={handleRepeatOrder} disabled={submitting}>
                Repeat Order
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      </>
    )
  );
};

export default RepeatOrder;
